import Vue from "vue";
import App from "./App.vue";
import router from "@/utils/router";
import store from "@/store";
import vuetify from "./plugins/vuetify";
import axios from "axios";

Vue.config.productionTip = false;

Vue.prototype.axios = axios;
Vue.prototype.API_URL = process.env.VUE_APP_API_URL;
Vue.prototype.IMG_URL = process.env.VUE_APP_IMG_URL;

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast);

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
